import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

// Generic screen used by every sidebar destination. Renders the module's title,
// subtitle and the capabilities planned for it. Replace the placeholder body of
// any individual module with its real UI as it gets built.
const ModulePage = ({ title, subtitle, features = [] }) => (
  <div className="p-8 max-w-5xl mx-auto">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-brand-deep">{title}</h1>
      {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
    </div>

    <div className="grid gap-4 sm:grid-cols-2">
      {features.map((f) => (
        <div key={f} className="flex items-start gap-3 bg-white border border-slate-200 rounded-xl p-4 shadow-sm">
          <CheckCircleIcon className="h-6 w-6 text-brand-teal shrink-0" />
          <span className="text-slate-700 text-sm">{f}</span>
        </div>
      ))}
    </div>

    <div className="mt-8 rounded-xl border border-dashed border-slate-300 bg-white/60 p-8 text-center">
      <div className="inline-block h-12 w-1 rounded bg-brand-gradient mb-3" />
      <p className="text-slate-400 text-sm">This module is scaffolded and ready to build out.</p>
    </div>
  </div>
);

export default ModulePage;
